import React, { useContext } from "react";
import AppFactory from "./AppFactory";

export const AppFactoryContext = React.createContext<AppFactory>(null!)

export const useAppFactory = () => useContext(AppFactoryContext);